export const SheetContentType = {
  menu: "menu",
  regionSelect: "region-select",
} as const;

export type SheetContentType =
  (typeof SheetContentType)[keyof typeof SheetContentType];

export const ModalContentType = {
  thirdParty: "third-party",
  personalData: "personal-data",
} as const;

export type ModalContentType =
  (typeof ModalContentType)[keyof typeof ModalContentType];
